export default [
  {
    path: "dashboardAffiliate",
    name: "dashboardAffiliate",
    component: (): Promise<any> => import(/* webpackChunkName: "dashboardAffiliate" */ "@/views/Admin/DashboardAffiliate.vue")
  }
];
